<script>
  import FormWrapper from './form-wrapper';

  export default {
    extends: FormWrapper,

    data() {
      return {
        isVisible: false,
      };
    },

    methods: {
      /**
       * @param {object|string|null} data
       */
      show(data = null) {
        if (_.isObject(data)) {
          this.formData = data;
        } else {
          this.getFormData(
            _.isString(data) ? data : this.formDataUrl
          );
        }

        this.isVisible = true;
      },

      /**
       * @return {undefined}
       */
      hide() {
        this.formData = null;
        this.isVisible = false;
      },

      /**
       * @return {undefined}
       */
      onFormDataReceiveError(error) {
        this.notifyFormDataReceiveError(error);
        this.hide();
      },

      /**
       * @return {undefined}
       */
      onMounted() {
        // overrides the parent method
      },
    },
  }
</script>
